// Master-only; the source day needs no resequence, the BE renumbers it on the flip.
import { makeChangeDayMasterSlotStep } from 'utils/routeStopOperations/v2/steps/changeDayMasterSlot'
import { makePreflightStep } from 'utils/routeStopOperations/v2/steps/preflight'
import { makeSequenceMasterSlotStep } from 'utils/routeStopOperations/v2/steps/sequenceMasterSlot'
import { makeVerifyStep } from 'utils/routeStopOperations/v2/steps/verify'

import type { ChangeDayOfWeekIntent, Deps, OperationPlan, PipelineStep } from 'types/modules/routing'

const STRATEGY_ID = 'v3-slot' as const

export const buildChangeDayOfWeekSlotPipeline = (intent: ChangeDayOfWeekIntent, deps: Deps): OperationPlan => {
  const steps: PipelineStep[] = [makePreflightStep({ intent }, deps) as PipelineStep]

  steps.push(
    makeChangeDayMasterSlotStep(
      { routeId: intent.routeId, toDayOfWeek: intent.toDayOfWeek, rows: intent.movedStops, futureStops: true },
      deps
    ) as PipelineStep
  )

  if (intent.destinationOrderedStops && intent.destinationOrderedStops.length > 0) {
    steps.push(
      makeSequenceMasterSlotStep(
        { routeId: intent.routeId, dayOfWeek: intent.toDayOfWeek, orderedRows: intent.destinationOrderedStops },
        deps
      ) as PipelineStep
    )
  }

  steps.push(makeVerifyStep({ intent }, deps) as PipelineStep)

  return { strategy: STRATEGY_ID, intent, steps }
}
